import {
  OVERLAY_ADD_OVERLAY,
  OVERLAY_CLOSE_OVERLAY,
  OVERLAY_REMOVE_OVERLAY,
  OVERLAY_UPDATE_OVERLAY,
} from '../constants';

export const addOverlay = (
  componentName,
  onOverlayClick,
  zIndexClass = null
) => ({
  type: OVERLAY_ADD_OVERLAY,
  payload: {
    componentName,
    onOverlayClick,
    zIndexClass,
  },
});

export const updateOverlay = (componentName, onOverlayClick, zIndexClass) => ({
  type: OVERLAY_UPDATE_OVERLAY,
  payload: {
    componentName,
    onOverlayClick,
    zIndexClass,
  },
});

export const removeOverlay = (componentName) => ({
  type: OVERLAY_REMOVE_OVERLAY,
  payload: {
    componentName,
  },
});

export const closeOverlay = () => ({
  type: OVERLAY_CLOSE_OVERLAY,
  payload: {
    activeOverlays: [],
  },
});
